import _ from 'lodash';

const getErrorMessage = (error: Error | string): string => (error instanceof Error ? error.message : error);

export const getErrorsText = (error: Error | Error[] | string | string[]): string => {
  if (!error) return 'Something went wrong.';

  return _.isArray(error) ? (error as Array<Error | string>).map(getErrorMessage).join('\n') : getErrorMessage(error);
};
